module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero-kids-302ea938b20dd0dbe02ebb31ca01ece5.svg";